import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useAlgoliaHost() {
  const { market } = useMarketplace()
  const { ALGOLIA_HOST } = useRuntimeConfig().public

  const url = computed(() =>
    ((ALGOLIA_HOST as string) || '')?.replaceAll(
      '{market.domain}',
      market.domain,
    ),
  )

  return {
    url,
    protocol: 'https',
  }
}
